<template>
    <div v-if="show_empty || !!value" >
        <v-container class="px1-0 py-0 ma-0">
            <v-row v-if="only_label" no-gutters>
                <v-col cols="12"><i>{{label}}</i></v-col>
            </v-row>
            <v-row no-gutters v-else>
            <v-col cols="4"><i>{{label}}:</i></v-col>
            <v-col cols="8" v-if="val_obj"><slot></slot></v-col>
            <v-col cols="8" v-else>{{c_val}}</v-col>
        </v-row>
        </v-container>
    </div>
</template>

<script>
export default {
    props: {
        'label':{
            type: String,
            required: true
        }, 
        'value': {
            type: String,
            required: false,
            default: null
        }, 
        "show_empty": {
            type: Boolean,
            required: false,
            default: true
        },
        "only_label": {
            type: Boolean,
            required: false,
            default: false
        },
        "val_obj": {
            type: Boolean,
            required: false,
            default: false
        }
    },
    computed: {
        c_val() {
            let val = this.value
            if (!this.value) {
                val="-"
            }
            return val
        }
    }
}
</script>
<style>

</style>
